var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex xs4 sm2 lg1"},[_c('div',{staticClass:"d-flex justify--center"},[_c('div',[_c('va-progress-circle',{attrs:{"indeterminate":""}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }